document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.toggleAttribute('hidden', open);
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('[data-gallery-main]');
      if (!main) return;
      main.src = thumb.dataset.src;
      main.alt = thumb.dataset.alt || '';
      document.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  document.querySelectorAll('[data-pack-selector]').forEach((selector) => {
    const form = selector.closest('[data-product-buybox]');
    if (!form) return;
    const quantity = form.querySelector('[name="quantity"]');
    const total = form.querySelector('[data-pack-total]');
    const unitPriceOutput = form.closest('.volt-product-info')?.querySelector('[data-pack-unit-price]');
    const defaultUnitPrice = Number(form.dataset.unitPrice || 0);
    const formatMoney = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    const update = (amount) => {
      const activeButton = selector.querySelector(`[data-pack="${amount}"]`);
      const unitPrice = Number(activeButton?.dataset.unitPrice || defaultUnitPrice);
      if (quantity) quantity.value = amount;
      selector.querySelectorAll('[data-pack]').forEach((button) => {
        button.classList.toggle('is-active', Number(button.dataset.pack) === Number(amount));
        button.setAttribute('aria-pressed', String(Number(button.dataset.pack) === Number(amount)));
      });
      if (total) total.textContent = formatMoney(unitPrice * amount);
      if (unitPriceOutput) unitPriceOutput.textContent = formatMoney(unitPrice);
    };
    selector.querySelectorAll('[data-pack]').forEach((button) => button.addEventListener('click', () => update(Number(button.dataset.pack))));
    update(Number(selector.querySelector('[data-pack].is-active')?.dataset.pack || 24));
  });

  document.querySelectorAll('[data-locator-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const shell = button.closest('.volt-locator-shell');
      const input = shell?.querySelector('input');
      const status = shell?.querySelector('[data-locator-status]');
      if (status) status.textContent = input?.value ? `Standortsuche für „${input.value}“ wird vor dem Launch mit Filialdaten verbunden.` : 'Bitte PLZ oder Ort eingeben.';
    });
  });

  const sticky = document.querySelector('[data-mobile-sticky]');
  const primaryAdd = document.querySelector('[data-primary-add]');
  if (sticky && primaryAdd) {
    sticky.hidden = false;
    sticky.querySelector('[data-sticky-add]')?.addEventListener('click', () => primaryAdd.click());
  }

});
